import React from 'react';
import { Calendar } from 'primereact/calendar';
import { useTranslation } from 'react-i18next';
import { Dropdown } from 'primereact/dropdown';
import SharedButton from '../../components/Shared/SharedButton';
import i18next from 'i18next';

const HisInvoicesFilters = ({
  filters,
  setFilters,
  handleAddFilters,
  filterLoading,
  handleResetFilters,
  showFilters
}) => {
  const { t } = useTranslation();
  const lang = i18next.language;

  const payment_method_values = [
    { value: '', label: lang === 'ar' ? 'الكل' : 'All' },
    { value: 'cash', label: lang === 'ar' ? 'نقدي' : 'Cash' },
    { value: 'card', label: lang === 'ar' ? 'بطاقة' : 'Card' },
    { value: 'bank', label: lang === 'ar' ? 'بنك' : 'Bank' },
    { value: 'mada', label: lang === 'ar' ? 'مدى' : 'MADA' },
    { value: 'cheque', label: lang === 'ar' ? 'يفحص' : 'Cheque' }
  ];

  return (
    <div className='mb-4'>
      <div className='flex flex-col md:flex-row md:items-end mb-3 gap-3 flex-wrap'>
        {/* Start Date */}
        <div className='flex-1 min-w-[200px]'>
          <label className='text-sm font-medium block mb-1'>{t('StartDate')}</label>
          <Calendar
            value={filters?.start_date ? new Date(filters.start_date) : null}
            onChange={e => {
              setFilters(prevValues => ({
                ...prevValues,
                start_date: e.value ? new Date(e.value.getTime() - (e.value.getTimezoneOffset() * 60000)).toISOString().split('T')[0] : ''
              }));
            }}
            dateFormat="dd-mm-yy"
            className='w-full'
            inputClassName='w-full border border-gray-300 rounded-md !p-1.5 hover:border-primary !outline-none !shadow-none'
          />
        </div>

        {/* End Date */}
        <div className='flex-1 min-w-[200px]'>
          <label className='text-sm font-medium block mb-1'>{t('EndDate')}</label>
          <Calendar
            value={filters?.end_date ? new Date(filters.end_date) : null}
            onChange={e => {
              setFilters(prevValues => ({
                ...prevValues,
                end_date: e.value ? new Date(e.value.getTime() - (e.value.getTimezoneOffset() * 60000)).toISOString().split('T')[0] : ''
              }));
            }}
            dateFormat="dd-mm-yy"
            className='w-full'
            inputClassName='w-full border border-gray-300 rounded-md !p-1.5 hover:border-primary !outline-none !shadow-none'
          />
        </div>

        {/* File Number */}
        <div className='flex-1 min-w-[200px]'>
          <label className='text-sm font-medium block mb-1'>{t('File Number')}</label>
          <input
            type='text'
            placeholder={t('Enter File Number')}
            className='w-full border border-gray-300 rounded-md !p-1.5 hover:border-primary !outline-none !shadow-none'
            value={filters?.filters?.file_number || ''}
            onChange={e => {
              setFilters(prevValues => ({
                ...prevValues,
                filters: {
                  ...prevValues.filters,
                  file_number: e.target.value
                }
              }));
            }}
          />
        </div>

        {/* Invoice Number */}
        <div className='flex-1 min-w-[200px]'>
          <label className='text-sm font-medium block mb-1'>{t('Invoice Number')}</label>
          <input
            type='text'
            placeholder={t('Enter Invoice Number')}
            className='w-full border border-gray-300 rounded-md !p-1.5 hover:border-primary !outline-none !shadow-none'
            value={filters?.filters?.invoice_number || ''}
            onChange={e => {
              setFilters(prevValues => ({
                ...prevValues,
                filters: {
                  ...prevValues.filters,
                  invoice_number: e.target.value
                }
              }));
            }}
          />
        </div>

        {/* Payment Method */}
        <div className='flex-1 min-w-[200px]'>
          <label className='text-sm font-medium block mb-1'>{t('payment_method')}</label>
          <Dropdown
            value={filters?.filters?.payment_method || ''}
            options={payment_method_values}
            onChange={e => {
              setFilters(prevDates => ({
                ...prevDates,
                filters: {
                  ...prevDates.filters,
                  payment_method: e.target.value
                }
              }));
            }}
            optionLabel='label'
            placeholder={t('Select Payment Method')}
            className={`!w-full !p-0 !border-gray-300 rounded-md hover:!border-primary !outline-none !shadow-none`}
            pt={{
              input: { className: '!w-full !p-1.5' },
              list: { className: '!py-0' },
              dropdownicon: { className: 'h-[13px] w-[13px]' }
            }}
          />
        </div>

        {/* Status */}
        {/* <div className='flex-1 min-w-[200px]'>
          <label className='text-sm font-medium block mb-1'>{t('Status')}</label>
          <Dropdown
            value={filters?.filters?.status || ''}
            options={status_values}
            onChange={e => {
              setFilters(prevDates => ({
                ...prevDates,
                filters: {
                  ...prevDates.filters,
                  status: e.target.value
                }
              }));
            }}
            optionLabel='label'
            placeholder={t('Select Status')}
            className={`!w-full !p-0 !border-gray-300 rounded-md hover:!border-primary !outline-none !shadow-none`}
            pt={{
              input: { className: '!w-full !p-1.5' },
              list: { className: '!py-0' },
              dropdownicon: { className: 'h-[13px] w-[13px]' }
            }}
          />
        </div> */}

        {/* Created By */}
        {/* <div className='flex-1 min-w-[200px]'>
          <label className='text-sm font-medium block mb-1'>{t('Created By')}</label>
          <input
            type='text'
            placeholder={t('Enter Created By')}
            className='w-full border border-gray-300 rounded-md !p-1.5 hover:border-primary !outline-none !shadow-none'
            value={filters?.filters?.created_by || ''}
            onChange={e => {
              setFilters(prevValues => ({
                ...prevValues,
                filters: {
                  ...prevValues.filters,
                  created_by: e.target.value
                }
              }));
            }}
          />
        </div> */}

        {/* Filter Button */}
        <div className='flex gap-2'>
          <SharedButton
            tooltip={t('Filter')}
            icon='pi pi-filter'
            onClick={handleAddFilters}
            loading={filterLoading}
            className='bg-primary primary-btn'
          />
          {showFilters && (
            <SharedButton
              tooltip={t('reset')}
              icon='pi pi-refresh'
              onClick={handleResetFilters}
              loading={filterLoading}
              className='bg-red-500 hover:bg-red-600 text-white'
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default HisInvoicesFilters;
